export const OFFER_DETAIL_PROPERTY_LIST_DEFAULT_PAGE_SIZE = 20;
export const OFFER_DETAIL_PROPERTY_LIST_TILES_DEFAULT_PAGE_SIZE = 20;
export const OFFER_DETAIL_PROPERTY_LIST_DEFAULT_PAGE_SIZE = 20;
export const OFFER_DETAIL_PROPERTY_LIST_TILES_DEFAULT_PAGE_SIZE = 20;
